import React, { useEffect, useState } from "react";
import fallLandscape from "../assets/images/fall-landscape.png";
import fallCanopyTop from "../assets/images/fall-canopy-top.png";
import fallLeafPile from "../assets/images/fall-leaf-pile-trimmed.png";
import sunglassesAcorn from "../assets/images/fall-acorn-sunglasses.png";
import cocoaGhost from "../assets/images/fall-ghost-hot-chocolate.png";
import amberLeaf from "../assets/images/fall-leaf-amber.png";
import curledMapleLeaf from "../assets/images/fall-leaf-maple-curled.png";
import edgeLeaf from "../assets/images/fall-leaf-edge.png";
import curledOakLeaf from "../assets/images/fall-leaf-oak-curled.png";

const leafImages = [amberLeaf, curledMapleLeaf, edgeLeaf, curledOakLeaf];

const driftingLeaves = [
  { left: "4%", delay: "-2s", duration: "17s", variant: 0, size: 62 },
  { left: "15%", delay: "-10s", duration: "22s", variant: 2, size: 51 },
  { left: "28%", delay: "-5s", duration: "19s", variant: 1, size: 69 },
  { left: "42%", delay: "-15s", duration: "24s", variant: 3, size: 56 },
  { left: "57%", delay: "-8s", duration: "18s", variant: 0, size: 53 },
  { left: "69%", delay: "-19s", duration: "25s", variant: 1, size: 66 },
  { left: "82%", delay: "-4s", duration: "20s", variant: 3, size: 59 },
  { left: "93%", delay: "-13s", duration: "23s", variant: 2, size: 50 },
];

export default function FallScene() {
  const [easterEgg, setEasterEgg] = useState(null);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;

    let timeoutId;
    const randomDelay = (minimum, maximum) =>
      Math.round(minimum + Math.random() * (maximum - minimum));

    const scheduleAppearance = (firstAppearance = false) => {
      timeoutId = window.setTimeout(
        () => {
          const direction = Math.random() > 0.5 ? 1 : -1;
          setEasterEgg({
            id: Date.now(),
            character:
              firstAppearance || Math.random() < 0.5
                ? sunglassesAcorn
                : cocoaGhost,
            left: `${8 + Math.random() * 80}%`,
            sway: `${55 * direction}px`,
            returnSway: `${-38 * direction}px`,
            lateSway: `${42 * direction}px`,
            finishSway: `${-18 * direction}px`,
          });

          timeoutId = window.setTimeout(() => {
            setEasterEgg(null);
            scheduleAppearance(false);
          }, 14000);
        },
        firstAppearance ? randomDelay(20000, 35000) : randomDelay(75000, 130000)
      );
    };

    scheduleAppearance(true);
    return () => window.clearTimeout(timeoutId);
  }, []);

  return (
    <>
      <div className="fall-scene fall-scene--ground" aria-hidden="true">
        <img className="fall-scene__landscape" src={fallLandscape} alt="" />
        <img className="fall-scene__pile" src={fallLeafPile} alt="" />
      </div>
      <div className="fall-scene fall-scene--sky" aria-hidden="true">
        <img className="fall-scene__canopy" src={fallCanopyTop} alt="" />
        <div className="fall-scene__drift">
          {driftingLeaves.map(({ left, delay, duration, variant, size }, index) => (
            <img
              key={`${left}-${delay}`}
              className={`fall-scene__leaf fall-scene__leaf--${variant}`}
              src={leafImages[variant]}
              alt=""
              style={{
                "--leaf-left": left,
                "--leaf-delay": delay,
                "--leaf-duration": duration,
                "--leaf-size": `${size}px`,
                "--leaf-drift": `${index % 2 === 0 ? 46 : -38}px`,
                "--leaf-return": `${index % 2 === 0 ? -30 : 25}px`,
                "--leaf-finish": `${index % 2 === 0 ? 16 : -13}px`,
                "--leaf-start-angle": `${index % 2 === 0 ? -22 : 18}deg`,
                "--leaf-mid-angle": `${index % 2 === 0 ? 62 : -48}deg`,
                "--leaf-late-angle": `${index % 2 === 0 ? 128 : -112}deg`,
                "--leaf-end-angle": `${index % 2 === 0 ? 194 : -176}deg`,
                "--leaf-flip": index % 3 === 0 ? -1 : 1,
              }}
            />
          ))}
          {easterEgg && (
            <img
              key={easterEgg.id}
              className="fall-scene__easter-egg"
              src={easterEgg.character}
              alt=""
              style={{
                "--acorn-left": easterEgg.left,
                "--acorn-sway": easterEgg.sway,
                "--acorn-return": easterEgg.returnSway,
                "--acorn-late": easterEgg.lateSway,
                "--acorn-finish": easterEgg.finishSway,
              }}
            />
          )}
        </div>
      </div>
    </>
  );
}
